
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Message } from "@/script/apps/wechat/entity/WechatEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { MessageService } from "@/script/apps/wechat/service/MessageService";
import { ElMessage } from "element-plus";

@Options({})
export default class MessageDetail extends BaseDetail {
  

  private service = new MessageService();

  public initData(): ServiceContext {
    return ServiceFactory.build(
      "biz_wechat_message",
      "/wechat/message",
      "/wechat/message",
      this.service
    );
  } 

  public newEntity() {
    const entity: Message = {};
    return entity;
  }

  
}
